"use client";

import React from "react";
import BaseButton, {BaseButtonProps} from "./BaseButton";

export type ButtonProps = BaseButtonProps;

const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(
   function Button(props, ref) {
      return <BaseButton {...props} ref={ref} />;
   }
);

Button.displayName = "Button";

export default Button;
